export const LEGAL_DOCS = {
  privacy: { path: '/privacy', title: 'Политика обработки персональных данных' },
  consent: { path: '/consent', title: 'Согласие на обработку персональных данных' },
  cookies: { path: '/cookies', title: 'Использование файлов cookie' },
} as const;
